import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/insights_analytics_event.py
export const INSIGHTS_ANALYTICS_ACTIONS = {
  // READ actions
  OPENED_INSIGHTS_MODULE: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_insights_module',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_DASHBOARD_FROM_SIDEPANEL: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_dashboard_from_sidepanel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  LOADED_QUERY: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'loaded_query',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_QUERY: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'ran_query',
    actionCategory: ACTION_CATEGORY.READ,
  },
  COPIED_TABLE_NAME_IN_SCHEMA_BROWSER: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'copied_table_name_in_schema_browser',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SEARCHED_IN_SCHEMA_BROWSER: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'searched_in_schema_browser',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_DASHBOARD_FROM_EXTERNAL_MODULE: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_dashboard_from_external_module',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_EMBEDDED_DASHBOARD_TAB: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_embedded_dashboard_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_SQL_AI_ASSISTANT_MODAL: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_sql_ai_assistant_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_TABLE_IN_SCHEMA_BROWSER: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_table_in_schema_browser',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_WAREHOUSE_DIAGRAM: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'opened_warehouse_diagram',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_RELATED_TABLES_TO_WAREHOUSE_DIAGRAM: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'added_related_tables_to_warehouse_diagram',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_QUERY_OUTPUT_AS_CSV: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'downloaded_query_output_as_csv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  COPIED_QUERY_OUTPUT_AS_TSV: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'copied_query_output_as_tsv',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REQUESTED_SQL_AI_ASSISTANT_SUGGESTION: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'requested_sql_ai_assistant_suggestion',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_SQL_AI_ASSISTANT_SUGGESTION_USEFULNESS: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'submitted_sql_ai_assistant_suggestion_usefulness',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // WRITE actions
  ACCEPTED_SQL_AI_ASSISTANT_SUGGESTION: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'accepted_sql_ai_assistant_suggestion',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_BLOCK: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'added_block',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_EMBEDDED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'added_embedded_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CHANGED_BLOCK_LAYOUT: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'changed_block_layout',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CHANGED_VISUALIZATION_TYPE: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'changed_visualization_type',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'created_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_BLOCK: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'deleted_block',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'deleted_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DUPLICATED_BLOCK: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'duplicated_block',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DUPLICATED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'duplicated_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INSERTED_PARAMETER: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'inserted_parameter',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MOVED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'moved_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_EMBEDDED_DASHBOARD: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'removed_embedded_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_PARAMETER_TYPE: {
    module: ANALYTICS_MODULE.INSIGHTS,
    action: 'updated_parameter_type',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
